import { useCallback, useMemo, useState } from 'react'
import { SortDirection } from '@mui/material'

import { GETSearchType } from '@types'

import { Sort } from '../lib/constants'
import { SearchAssistantPresenter } from '../presenter/search-assistant.presenter'

interface SortSearchFilterManagerHookProps {
  searchAssistantPresenter: SearchAssistantPresenter
  savedSearchFilters: GETSearchType[]
}

export const useSortSearchFilterManager = (props: SortSearchFilterManagerHookProps) => {
  const { searchAssistantPresenter, savedSearchFilters } = props

  const [sort, setSort] = useState<SortDirection>(false)

  const orderedSearchFilters = useMemo(
    () => searchAssistantPresenter.getOrderedSearchFilters(savedSearchFilters, sort),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [savedSearchFilters, sort]
  )

  const handleNameColumnSort = useCallback(() => {
    if (sort === Sort.Asc) {
      setSort(Sort.Desc)

      return
    }
    if (sort === Sort.Desc) {
      setSort(false)

      return
    }
    if (!sort) {
      setSort(Sort.Asc)
    }
  }, [sort])

  return { orderedSearchFilters, sort, handleNameColumnSort }
}
